import { render } from "./AppFaq.vue?vue&type=template&id=0d6c235c&scoped=true"
import script from "./AppFaq.vue?vue&type=script&lang=js"
export * from "./AppFaq.vue?vue&type=script&lang=js"

import "./AppFaq.vue?vue&type=style&index=0&id=0d6c235c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6c235c"]])

export default __exports__